import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg';

function MissedCall(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(G, {
    clipPath: "url(#prefix__clip0_1982_2430)"
  }, React.createElement(Path, {
    fillRule: "evenodd",
    d: "M21.236 18.032a2.059 2.059 0 01-2.131 1.933l-2.383-.088a1.737 1.737 0 01-1.584-1.187l-.445-1.336a8.79 8.79 0 00-1.659-.363c-1.133-.135-2.56-.08-3.958.587l-.21.914a1.737 1.737 0 01-1.735 1.346l-2.456-.059a1.835 1.835 0 01-1.736-1.388c-.487-1.946.154-4.216 2.115-5.234 4.13-2.143 8.665-2.077 12.652-.769 2.443.801 3.674 3.264 3.53 5.644zm-5.505-2.146c.226.099.4.288.478.522l.577 1.733 2.383.088a.321.321 0 00.333-.302c.108-1.786-.815-3.389-2.337-3.888-3.643-1.195-7.68-1.223-11.31.66-1.075.558-1.574 1.899-1.23 3.27.01.042.048.072.092.073l2.456.059.301-1.306a.868.868 0 01.427-.566c1.921-1.06 3.887-1.136 5.338-.963.729.086 1.341.237 1.774.367.242.073.484.152.716.253h.002z",
    clipRule: "evenodd"
  }), React.createElement(Path, {
    d: "M7.377 4.421c.222-.23.59-.23.812 0L12 8.375l3.106-3.222h-1.974a.576.576 0 010-1.153H16.5a.5.5 0 01.5.5v3.555a.556.556 0 11-1.111 0v-2.09L12.36 9.627a.5.5 0 01-.72 0L7.377 5.204a.564.564 0 010-.783z"
  })), React.createElement(Defs, null, React.createElement(ClipPath, {
    id: "prefix__clip0_1982_2430"
  }, React.createElement(Path, {
    d: "M0 0h24v24H0z"
  }))));
}

export default MissedCall;